var d1 = "/static/b9b287d2485b633f.png";

export { d1 as default };
//# sourceMappingURL=d_1.png.js.map
